"use client";
import dynamic from "next/dynamic";
import type React from "react";

const Header = dynamic(
  () => import("../_components/header/index").then((mod) => mod.Header),
  {
    ssr: true,
    loading: () => <div style={{ height: "100px" }} />,
  }
);

const Footer = dynamic(
  () => import("../_components/footer/index").then((mod) => mod.Footer),
  {
    ssr: false,
    loading: () => <div style={{ height: "100px" }} />,
  }
);

export default function Layout({
  children,
}: Readonly<{
  children: React.ReactNode;
}>) {
  return (
    <>
      <Header />
      {children}
      <Footer />
    </>
  );
}
